import { CloseIcon } from "@chakra-ui/icons";
import { Box, IconButton } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { RanaMapFullscreen } from "@/lib/rana-map";

import { RanaRasterColorSettings } from "./components/rana-raster-color-settings";
import { PublicationRasterDetailsProps } from "./types/rana-raster-types";

export function RanaRasterDetails(props: PublicationRasterDetailsProps) {
  const { onCloseDetails } = props;

  return (
    <Box overflow="auto" maxH="xs" flexDirection="column" h="full" w="xs" px={2}>
      <RanaMapFullscreen.ControlsHeader>
        <FormattedMessage id="rightbar.details" defaultMessage="Details" />
        {onCloseDetails !== undefined && (
          <IconButton
            top={1}
            right={1}
            position="absolute"
            aria-label="close"
            variant="ghost"
            size="xs"
            colorScheme="gray"
            icon={<CloseIcon />}
            onClick={onCloseDetails}
          />
        )}
      </RanaMapFullscreen.ControlsHeader>

      <RanaRasterColorSettings {...props} />
    </Box>
  );
}
